<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="14.5" cy="14.5" r="12.5" fill="#E7EDF0" />
    <path
      d="M22.4814 14.1428H7.44434V25.9285H22.4814V14.1428Z"
      fill="#8ED5E3"
    />
    <path
      d="M4 14.3484V27.5714H7.41751V15.4983H22.064V27.5714H25.4815V14.3484L14.7407 4L4 14.3484Z"
      fill="white"
    />
    <path
      d="M4.22266 13.0715V25.9287H7.64016V14.2404H22.2866V25.9287H25.7041V13.0715"
      stroke="#061A36"
      stroke-miterlimit="10"
    />
    <path
      d="M2.07422 15.2143L14.9631 4.5L27.852 15.2143"
      stroke="#061A36"
      stroke-miterlimit="10"
    />
    <path
      d="M9.59277 17.3572H20.3335"
      stroke="#061A36"
      stroke-miterlimit="10"
    />
    <path d="M9.59277 19.5H20.3335" stroke="#061A36" stroke-miterlimit="10" />
    <path
      d="M9.59277 21.6428H20.3335"
      stroke="#061A36"
      stroke-miterlimit="10"
    />
    <path
      d="M9.59277 23.7856H20.3335"
      stroke="#061A36"
      stroke-miterlimit="10"
    />
  </svg>
</template>
